import React, {useEffect, useMemo, useState} from 'react';
import {
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {format} from 'date-fns';
import CaseNotificationEnum from './CaseNotiFicationEnum';

const CreateDateEditPopup = ({open, onClose, createDate, caseId, onUpdate, users, role}) => {
    const [selectedDate, setSelectedDate] = useState(null);

    const originalDate = useMemo(() => (createDate ? new Date(createDate) : null), [createDate]);

    useEffect(() => {
        if (open && originalDate) {
            setSelectedDate(originalDate);
        }
    }, [open, originalDate]);

    const sendNotificationForNote = async (oldValue, newValue) => {
        const headOfAgency = users.find(user => user.roleName === 'HeadOfAgency');
        const deputyHeadOfAgency = users.find(user => user.roleName === 'DeputyHeadOfAgency');

        const nextStepUserId =
            role === 'HEADOFAGENCY'
                ? deputyHeadOfAgency && deputyHeadOfAgency.id
                : headOfAgency && headOfAgency.id;

        const caseNotification = {
            nextStepUserId,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.editedField.id,
            caseStatus: 8,
            viewed: true,
            key: ['შექმნის თარიღი'],
            oldValue: [oldValue],
            newValue: [newValue]
        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const handleSave = async () => {
        if (!selectedDate || !caseId) return;

        const mergedDate = new Date(selectedDate);
        if (originalDate) {
            mergedDate.setHours(
                originalDate.getHours(),
                originalDate.getMinutes(),
                originalDate.getSeconds(),
                originalDate.getMilliseconds()
            );
        } else {
            mergedDate.setHours(0, 0, 0, 0);
        }

        const formattedOldValue = originalDate ? format(originalDate, 'dd/MM/yyyy') : '';
        const formattedNewValue = format(mergedDate, 'dd/MM/yyyy');

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/EditCaseCreateDate`, {
                id: caseId,
                createDate: mergedDate.toISOString()
            });
            await sendNotificationForNote(formattedOldValue, formattedNewValue);
            if (onUpdate) onUpdate();
            onClose();
        } catch (error) {
            console.error('Failed to update create date', error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                რეგისტრაციის თარიღის რედაქტირება
                <IconButton aria-label="close" onClick={onClose} style={{position: 'absolute', right: 8, top: 8}}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div style={{marginTop: 20}} />
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label="რეგისტრაციის თარიღი"
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        format="dd/MM/yyyy"
                        renderInput={(params) => <TextField fullWidth {...params} />}
                    />
                </LocalizationProvider>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>გაუქმება</Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                    შენახვა
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateDateEditPopup;
